var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.684 7.949a.6.6 0 0 1-.463.336l-6.387.842a.6.6 0 0 0-.335 1.03l4.673 4.436a.6.6 0 0 1 .177.544l-1.173 6.335a.6.6 0 0 0 .876.636l5.662-3.073a.6.6 0 0 1 .572 0l5.662 3.073a.6.6 0 0 0 .877-.636l-1.173-6.335a.6.6 0 0 1 .176-.544l4.673-4.436a.6.6 0 0 0-.335-1.03l-6.387-.842a.6.6 0 0 1-.463-.336l-2.774-5.814a.6.6 0 0 0-1.083 0L8.684 7.949zM12 5.644 10.49 8.81a2.6 2.6 0 0 1-2.008 1.458l-3.478.459 2.545 2.415a2.6 2.6 0 0 1 .766 2.36l-.639 3.449 3.084-1.674a2.6 2.6 0 0 1 2.48 0l3.084 1.674-.639-3.45a2.6 2.6 0 0 1 .767-2.359l2.544-2.415-3.478-.459A2.6 2.6 0 0 1 13.51 8.81l-1.51-3.166z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOpen);
export default __webpack_public_path__ + "static/media/star-open.18c8e9813e8856b3a91a5e9423f166a2.svg";
export { ForwardRef as ReactComponent };